export default __webpack_public_path__ + "static/media/sevenPieces5.814e7c90.jpg";